var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModelCustom = function SvgModelCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M27.954 14.394a15.55 15.55 0 0 1 17.807-3.074l-7.662 7.722a3.964 3.964 0 0 0 0 5.576l1.846 1.861a3.89 3.89 0 0 0 5.533 0l7.662-7.722a15.85 15.85 0 0 1-4.716 19.4 15.58 15.58 0 0 1-16.143 1.624l-13.863 13.97a3.89 3.89 0 0 1-5.532 0L11.04 51.89a3.96 3.96 0 0 1 0-5.576L24.905 32.34a15.85 15.85 0 0 1 3.049-17.946Z"
  })));
};
export default SvgModelCustom;